export class LoadNotices {
  static readonly type = '[Notice] Load all notices';

  constructor(public body: { search: string; showArchived: boolean; statusId: number; endDate: string; limit: number; clerkId: number; page: number; userId: number; categoryId: number; startDate: string, assigned: string }) {}
}
